module.exports = __webpack_public_path__ + "static/img/8.705abb4a.png";